import { CLIENT_HOST } from 'src/config-global';

export const getSiteName = () => {
  if (CLIENT_HOST) {
    return CLIENT_HOST;
  }
  try {
    const { hostname, port } = window.location;
    if (port) {
      return `${hostname}:${port}`;
    }
    return hostname;
  } catch {
    return '';
  }
};
